module.exports = __webpack_public_path__ + "static/img/qqyy.8f628ed8.jpg";